import { cache } from '@dimjs/utils';

const isSessionStorageEnabled = () => {
  return (
    typeof sessionStorage !== 'undefined' &&
    typeof sessionStorage.setItem !== 'undefined' &&
    typeof sessionStorage.getItem !== 'undefined'
  );
};

const sessionSeedCacheKey = 'callback_id_seed_factory';
const starter = () => {
  return isSessionStorageEnabled()
    ? Number(sessionStorage.getItem(sessionSeedCacheKey) || '1')
    : 1;
};

/**
 * 当页面刷新的时候我们必须保证当前webview的callbackId计数器起点不重复, 因为bridge设计的时候可能存在刷新的时候Native清理掉上一次的callback函数引用
 * 一旦reload 页面刚好重新注册了一个与reload之前一样的callback函数签名, 就会导致callback回调函数不能在被执行了.
 * @param type
 * @returns
 */
export const callbackIdFactory = (type: 'ios' | 'android' | 'harmony') => {
  const cacheKey = `fabric_${type}_cb_`;
  const cacheFn = cache(cacheKey, starter);
  return () => {
    const callbackId = cacheFn();
    if (isSessionStorageEnabled()) {
      const newStartIndex = /\d+$/.exec(callbackId);
      sessionStorage.setItem(
        sessionSeedCacheKey,
        newStartIndex ? newStartIndex[0] : '1'
      );
    }
    return callbackId;
  };
};
